// ======================================================================
// File Name       : TableHead.js
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import React from 'react';
import TableCell from './TableCell';

/**
 * Create Sort function for table head
 * Return item sort:
 *    sortBy: item on sort
 *    sortState: sort direction (1: sort by asc, 0: sort by desc)
 */
class TableHead extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.data.map((el, i) => ({ index: i, isSort: false, sortState: 0, ...el })),
    };
  }

  updateSortState(item) {
    const sortOrder = item.sortState;
    const newData = this.state.data.map((el, i) => {
      el.sortState = 0;
      el.isSort = false;
      return el;
    });
    newData[item.index].isSort = true;
    newData[item.index].sortState = sortOrder;
    this.setState({
      data: newData,
    });

    this.props.handleSortState(item);
  }

  render() {
    const data = this.props.data.map((el, i) => ({ index: i, isSort: false, sortState: 0, ...el }));
    const th = data.map((item, index) =>
      (<TableCell
        key={index}
        cell={item}
        handleUpdateSortState={this.updateSortState.bind(this)}
        width={item.width}
      />),
    );

    return (
      <tr>
        {th}
      </tr>
    );
  }
}

export default TableHead;

export function setSortState(data, sortBy, sortState) {
  data.map((col, index) => {
    if (col.sortBy === sortBy) {
      col.isSort = true;
      col.sortState = sortState;
    }
    return col;
  });
  return data;
}
